<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加</el-button>
            <el-button  class="top-btn" type="success" plain @click="handleBatch(1)">启用</el-button>
            <el-button  class="top-btn" type="info"    plain @click="handleBatch(2)">禁用</el-button>
            <el-button  class="top-btn" type="danger"  plain @click="handleBatch(3)" >删除</el-button>
        </div>
        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无角色" height="610"  style="width:100%;">
                <el-table-column type="selection"  width="100"     align="center"> </el-table-column>
                <el-table-column prop="title"      label="名称"    width="260" ></el-table-column>
                <el-table-column prop="describe"   label="描述"    width="300" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="status"     label="状态"    width="160"   align="center" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="small"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="small"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>角色名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="title" placeholder="请输入角色名称"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>角色描述：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="describe" placeholder="请输入角色描述"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>状态：</p>
                </el-col>
                <el-col :span="18">
                    <el-radio v-model="status" :label="1" border>启用</el-radio>
                    <el-radio v-model="status" :label="0" border>禁用</el-radio>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>选择角色权限：</p>
                </el-col>
                <el-col :span="18">
                    <el-cascader v-model="marks" :options="options" @change="handleMarks" :props="{ multiple:true,emitPath:false }" collapse-tags separator="-" clearable style="width:100%"></el-cascader>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { roles, roles_add, roles_put, roles_del, permission } from '@/api/platform.js'

export default {
    data() {
        return {
            tableData: [],
            page:1,
            size:20,
            total:0,
            dialog:false,    // 控制显示 添加修改弹窗
            ids:[],          // table 选中数据的 id 数组集合
            dialogTitle:'添加栏目',
            id:'',           //  有id 是修改  没有id是添加
            title:'',
            describe:'',
            status:1,
            marks:[],       // 所选权限
            options:[],
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            let params = {
                page:this.page
            }
            roles(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            })
        },
        reloadData(page){
            this.page = page
            this.handleData()
        },
        // 获取权限
        handlePermission(){
            permission().then(res => {
                let arr = []
                res.data.forEach(e => {
                    let obj = {
                        label:e.title,
                        value:e.id,
                        children:[]
                    }
                    if(e.rules){
                        e.rules.forEach(el => {
                            obj.children.push({ label:el.title,value:el.mark })
                        })
                    }
                    
                    arr.push(obj)
                })
                this.options = arr
            })
        },
        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.dialogTitle = '修改栏目'
                this.id          = row.role_id
                this.title       = row.title
                this.describe    = row.describe
                this.status      = row.status
                this.marks       = row.permission.split(',')
            }else{
                this.dialog      = true
                this.dialogTitle = '添加栏目'
                this.id          = ''
                this.title       = ''
                this.describe    = ''
                this.status      = 1
                this.marks       = []
    
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                title:this.title,
                describe:this.describe,
                status:this.status,
                permission:this.marks.join(','),
            }
            roles_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改栏目函数
        handlePut(){
            let params = {
                title:this.title,
                describe:this.describe,
                status:this.status,
                permission:this.marks.join(','),
            }
            roles_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                    
                }
            })
        },
        // 修改状态
        handleStatus(row){
            let params = {
                status:row.status
            }
            roles_put(row.role_id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 点击删除 
        handleDel(it){
            this.$confirm(`此操作将删除 ${it.title} 权限, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                roles_del(it.role_id).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.role_id)
            })
        },
        // 批量操作  1 启用 2 禁用 3 删除
        handleBatch(index){
            if(this.ids.length == 0){
                this.$message({type:'error',message:'请至少选中一条数据进行批量操作哦',})
                return false;
            }
            if(index == 1){
                let params = {
                    status:1
                }
                roles_put(this.ids,params).then(res => {
                    if(res){
                        this.handleData()
                        this.$message({type:'success',message:res.msg,duration:1500})
                    }
                })
            }else if(index == 2){
                let params = {
                    status:0
                }
                roles_put(this.ids,params).then(res => {
                    if(res){
                        this.handleData()
                        this.$message({type:'success',message:res.msg,duration:1500})
                    }
                })
            }else if(index == 3){
                this.$confirm(`此操作将删除所有选中的角色, 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    roles_del(this.ids).then(res => {
                        this.$message({type:'success',message:res.msg})
                        this.handleData();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        },
        handleMarks(){
            console.log(this.marks)
        }
    },
    created(){
        this.handleData();
        this.handlePermission();
    }
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>